import { Injectable } from '@angular/core';
import { Apollo, QueryRef } from 'apollo-angular';
import { qualityDocumentStatus } from '@modelos/enum/enums';
import {
  Get_AssayDocuments,
  Link_AssayDocument,
  Unlink_AssayDocument,
  Update_AssayDocument
} from 'app/graphql/assayDocuments.graphql';

export interface IAssayDocumentItem {
  id: string;
  assayId?: string | null;
  assayAnaliteId?: string | null;
  qualityDocumentId: string;
  role: 'PRINCIPAL' | 'AUXILIAR';
  notes?: string | null;
  created?: string;
  updated?: string;
  v_?: number;
  qualityDocument?: any;
  assayAnalite?: any;
}

@Injectable({
  providedIn: 'root'
})
export class AssayDocumentsService {
  constructor(private apollo: Apollo) {}

  watchAssayDocuments(assayId?: string, assayAnaliteId?: string, generalOnly?: boolean): QueryRef<{ assayDocuments: IAssayDocumentItem[] }> {
    return this.apollo.watchQuery<{ assayDocuments: IAssayDocumentItem[] }>({
      query: Get_AssayDocuments,
      variables: {
        assayId: assayId || undefined,
        assayAnaliteId: assayAnaliteId || undefined,
        generalOnly: generalOnly || undefined
      },
      fetchPolicy: 'network-only'
    });
  }

  getAssayDocuments(assayId?: string, assayAnaliteId?: string, generalOnly?: boolean) {
    return this.apollo.query<{ assayDocuments: IAssayDocumentItem[] }>({
      query: Get_AssayDocuments,
      variables: {
        assayId: assayId || undefined,
        assayAnaliteId: assayAnaliteId || undefined,
        generalOnly: generalOnly || undefined
      },
      fetchPolicy: 'network-only'
    });
  }

  linkAssayDocument(data: {
    assayId?: string | null;
    assayAnaliteId?: string | null;
    qualityDocumentId: string;
    role: 'PRINCIPAL' | 'AUXILIAR';
    notes?: string | null;
  }) {
    return this.apollo.mutate<{ linkAssayDocument: IAssayDocumentItem }>({
      mutation: Link_AssayDocument,
      variables: {
        data
      }
    });
  }

  unlinkAssayDocument(id: string) {
    return this.apollo.mutate<{ unlinkAssayDocument: IAssayDocumentItem }>({
      mutation: Unlink_AssayDocument,
      variables: {
        id
      }
    });
  }

  updateAssayDocument(id: string, data: { role?: 'PRINCIPAL' | 'AUXILIAR'; notes?: string | null }) {
    return this.apollo.mutate<{ updateAssayDocument: IAssayDocumentItem }>({
      mutation: Update_AssayDocument,
      variables: {
        id,
        data
      }
    });
  }

  getValidQualityDocVersion(qualityDoc: any) {
    if (!qualityDoc?.versions?.length) return null;
    for (let i = qualityDoc.versions.length - 1; i >= 0; i--) {
      if (qualityDoc.versions[i].status === qualityDocumentStatus.VALID) {
        return qualityDoc.versions[i];
      }
    }
    return qualityDoc.versions[qualityDoc.versions.length - 1];
  }
}
